namespace TabAurous.OMS {
    export interface SubCategoryMasterRow {
        SubCategoryId?: number;
        SubCategoryCode?: string;
        SubCategoryName?: string;
        CategoryId?: number;
        CategoryName?: string;
        FixedName?: string;
        CalcOnId?: number;
        ItemTypeId?: number;
        CalcUnitId?: number;
        CostMethodId?: number;
        IsDisabled?: boolean;
        Details?: number[];
        PointerWeight?: number;
    }

    export namespace SubCategoryMasterRow {
        export const idProperty = 'SubCategoryId';
        export const nameProperty = 'SubCategoryCode';
        export const localTextPrefix = 'OMS.SubCategoryMaster';
        export const lookupKey = 'OMS.SubCategoryMaster';

        export function getLookup(): Q.Lookup<SubCategoryMasterRow> {
            return Q.getLookup<SubCategoryMasterRow>('OMS.SubCategoryMaster');
        }
        export const deletePermission = 'Product:SubCategory:Delete';
        export const insertPermission = 'Product:SubCategory:Add';
        export const readPermission = '*';
        export const updatePermission = 'Product:SubCategory:Edit';

        export declare const enum Fields {
            SubCategoryId = "SubCategoryId",
            SubCategoryCode = "SubCategoryCode",
            SubCategoryName = "SubCategoryName",
            CategoryId = "CategoryId",
            CategoryName = "CategoryName",
            FixedName = "FixedName",
            CalcOnId = "CalcOnId",
            ItemTypeId = "ItemTypeId",
            CalcUnitId = "CalcUnitId",
            CostMethodId = "CostMethodId",
            IsDisabled = "IsDisabled",
            Details = "Details",
            PointerWeight = "PointerWeight"
        }
    }
}
